import axios from 'axios'

// axios.defaults.withCredentials = true// 允许跨域设置，不然可能因为拿不到cookie而报错

// axios.defaults.baseURL = 'https://www.lhbbb.xyz'  
// axios.defaults.baseURL = 'http://localhost:8080'  //开发环境测试

/*请求拦截*/
// axios.interceptors.request.use(
//   config => {

//     return config
//   }, error => {
//     return Promise.reject(error)
//   }
// )
// /* 响应拦截 */
// axios.interceptors.response.use(
//   res => {
//    /*可在这里根据返回的状态码做一些拦截操作*/
//     return res
//   }, err => {
//     return Promise.resolve(err)
//   }
// )
export default axios  /*记得导出*/
